
<template>
  <div class="menuList" :class="{ 'mobile-view': isMobile, 'menu-open': isMobile && isExpanded }">
    <!-- Menu Toggle Icon (visible only on mobile) -->
    <div class="menu-toggle" v-if="!isExpanded" @click="toggleMenu">
      <span class="material-icons">menu</span>
    </div>
    <!-- Sidebar content -->
    <transition name="slide-fade">
      <div class="menu-content" v-if="!isMobile || isExpanded">
        <!-- Logo -->
        <div class="logo">
          <img src="@/assets/images/kenscio-logo-removebg-preview.png" alt="kenscio-logo" />
        </div>
        <h1><span class="highlight">K</span>enlyser</h1>
        <!-- Navigation Links -->
        <div class="menu-items">
          <router-link 
          to="/emailDashboard" 
          class="button" 
          :class="{ active: isActive('/emailDashboard') }" 
          @click="closeMenu"
        >
          <span class="material-icons">dashboard</span>
          <span v-if="!isMobile || isExpanded" class="label">Dashboard</span>
        </router-link>
          <router-link 
            to="/emailReport/" 
            class="button" 
            :class="{ active: isActive('/emailReport/') }" 
            @click="closeMenu"
          >
            <span class="material-icons">email</span>
            <span v-if="!isMobile || isExpanded" class="label">EmailReport</span>
          </router-link>
          <router-link 
            to="/userDetails" 
            class="button" 
            :class="{ active: isActive('/userDetails') }" 
            @click="closeMenu"
          >
            <span class="material-icons">group</span>
            <span v-if="!isMobile || isExpanded" class="label">UserDetail</span>
          </router-link>

          <router-link 
            to="/notifications" 
            class="button" 
            :class="{ active: isActive('/notifications') }" 
            @click="closeMenu"
          >
            <span class="material-icons">notifications</span>
            <span v-if="!isMobile || isExpanded" class="label">Notifications</span>
          </router-link>

          <router-link 
            to="/addDomain" 
            class="button" 
            :class="{ active: isActive('/addDomain') }" 
            @click="closeMenu"
          >
            <span class="material-icons">settings</span>
            <span v-if="!isMobile || isExpanded" class="label">Settings</span>
          </router-link>
        </div>
        <!-- Profile Section -->
        <div class="sidebar-profile" @click="toggleDropdown">
          <div v-if="!isMobile || isExpanded" class="profile-info">
            <div class="profile-icon w-24">
              <span class="material-icons">account_circle</span>
            </div>
            <!-- <span class="material-icons dropdown-icon">arrow_drop_down</span> -->
          </div>
          <!-- Dropdown -->
          <div v-if="showDropdown" class="profile-dropdown">
            <p class="dropdown-item"><strong>{{userEmail}}</strong></p>
            <button class="logout-btn" @click.stop="logout">Logout</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import sideMenuBar from './sideMenuBar';
export default sideMenuBar;
</script>

<style lang="scss" src="./sideMenuBar.scss"></style>